<script>
  import { Bar, Line, mixins } from 'vue-chartjs';

  export default {
    name   : 'line-chart',
    mixins : [ Line, Bar, mixins.reactiveProp ],
    props  : {
      chartData: {type: Object, default: () => null},
      options  : {type: Object, default: () => null}
    },
    data   : () => ({}),
    mounted() {
      this.renderChart(this.chartData, this.options);
    },
    methods: {},
  }
</script>

